import { useAuthStore } from '../../stores/auth'
import OrderBoard from '@/views/OrderBoard/OrderBoard.vue'
import Quotations from '@/views/Quotations.vue'

const hasAnyPermission = (permissions) => {
    const authStore = useAuthStore();
    return permissions.some(permission => authStore.hasPermission(permission));
};

export const operationsRoutes = [
    {
        path: 'products',
        name: 'products',
        component: () => import('../../views/Products.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'products.view'
        }
    },
    {
        path: 'orders',
        name: 'orders',
        component: () => import('../../views/Orders.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'orders.view'
        }
    },
    {
        path: 'orders/pending',
        name: 'pending-orders',
        component: () => import('../../views/Orders.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'orders.view',
            defaultFilters: {
                status: 'pending'
            }
        }
    },
    {
        path: 'orders/create',
        name: 'order-create',
        component: () => import('../../components/orders/OrderForm.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'orders.create'
        }
    },
    {
        path: 'orders/:id/edit',
        name: 'order-edit',
        component: () => import('../../components/orders/OrderForm.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'orders.edit'
        }
    },
    {
        path: 'orders/:id',
        name: 'order-details',
        component: () => import('../../views/OrderDetails.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'orders.view'
        }
    },
    {
        path: '/orders/board',
        name: 'order-board',
        component: OrderBoard,
        meta: {
            requiresAuth: true,
            title: 'Order Board',
            requiredPermission: 'orders.view',
            breadcrumb: [
                { name: 'Orders', to: { name: 'orders' } },
                { name: 'Order Board' }
            ]
        }
    },
    {
        path: 'quotations',
        name: 'quotations',
        component: Quotations,
        meta: {
            requiresAuth: true,
            permissions: ['quotations.view'],
            title: 'Quotations'
        },
        beforeEnter: (to, from, next) => {
            if (hasAnyPermission(to.meta.permissions)) {
                next();
            } else {
                next({ name: 'forbidden' });
            }
        }
    },
    {
        path: 'quotations/:id/edit',
        name: 'quotation-edit',
        component: () => import('../../components/clients/QuotationCreateModal.vue'),
        props: route => ({
            editMode: true,
            quotationId: route.params.id,
            modelValue: true
        }),
        meta: {
            requiresAuth: true,
            permissions: ['quotations.edit'],
            title: 'Edit Quotation'
        },
        beforeEnter: (to, from, next) => {
            if (hasAnyPermission(to.meta.permissions)) {
                next();
            } else {
                next({ name: 'forbidden' });
            }
        }
    },
    {
        path: 'printer-dashboard',
        name: 'printer-dashboard',
        component: () => import('../../views/PrinterDashboard.vue'),
        meta: {
            requiresAuth: true,
            title: 'Printer Dashboard',
            requiredPermission: 'orders.view'
        }
    },
    {
        path: 'layouting-dashboard',
        name: 'layouting-dashboard',
        component: () => import('../../views/LayoutingDashboard.vue'),
        meta: {
            requiresAuth: true,
            title: 'Layouting Dashboard',
            requiredPermission: 'orders.view'
        }
    },
    {
        path: 'quality-check-dashboard',
        name: 'quality-check-dashboard',
        component: () => import('../../views/QualityCheckDashboard.vue'),
        meta: {
            requiresAuth: true,
            title: 'Quality Check Dashboard',
            requiredPermission: 'orders.quality_check'
        }
    },
    {
        path: 'storage-gallery',
        name: 'storage-gallery',
        component: () => import('../../views/StorageGallery.vue'),
        meta: {
            requiresAuth: true,
            title: 'Storage Gallery',
            requiredPermission: 'storage.gallery.view'
        }
    }
];
